import { useCallback, useEffect, useState } from "react";
import { CustomButton } from "../../../components/CustomButton";
import RModal from "../../../components/Rsuite/Modal";
import { Text } from "../../../components/Text/Text";
import api from "../../../services/api";
import { NotificationManager } from "react-notifications";
import { generatePassword } from "../../../utils/generatePassword";

const ResetarSenhaUsuario = ({  
  modal,
  close,
  usuario
}) => {
  const [newPassword, setNewPassword] = useState('');

  const resetarSenha = useCallback(async () => {
    await api.patch(`gestor/resetarSenha/${usuario?.Id}`, {
      Senha: newPassword
    })
    .then(() => {
      NotificationManager.success('Senha resetada', 'Sucesso')
      close();
    })
    .catch(() => NotificationManager.warning('Não foi possível resetar a senha', 'Erro'))
  },[close, usuario?.Id, newPassword])

  useEffect(() => {
    setNewPassword(generatePassword())
  },[modal])

  return(
    <RModal
      open={modal}
      onClose={close}
      title={`Deseja resetar a senha do usuario ${usuario.Nome} ?`}
      footer={
        <>
          <CustomButton
            onClick={resetarSenha}
            appearance="primary" color="red"
          >
            Resetar
          </CustomButton>
          <CustomButton onClick={close} appearance="default" >
            Fechar
          </CustomButton>
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column'}}>
        <Text size="md" style={{ margin: '10px 0px'}}>A senha será redefinida para: <b>"{newPassword}"</b></Text>
        <Text size="sm" variant="info">Recomendamos que, após realizar o próximo acesso, altere imediatamente esta senha para uma de preferência do usuário, garantindo maior segurança das informações.</Text>
      </div>
    </RModal>
  )
}

export default ResetarSenhaUsuario;